export const formErrorsToString = errors => {
  if (!errors || errors.length === 0) return null
  let string = ''
  errors.map((error, i) => {
    error.messages.map(msg => {
      string += `${msg}. `
    })
  })
  return string
}

export const errorsToString = errors => {
  if (!errors || errors.length === 0) return null
  let string = ''
  errors.map((error, i) => {
    string += `${error}. `
  })
  return string
}

export const mutationWarningsToMessages = warnings =>
  (warnings || []).flatMap(warning => warning.messages || [])

export const dateToString = stringDate => {
  const date = new Date(stringDate)
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export const dateToShortString = (stringDate: string) => {
  const date = new Date(stringDate)
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export const dateAddDays = (date: Date, days: number): Date => {
  const newDate = date
  newDate.setDate(date.getDate() + days)
  return newDate
}
